'use client';

import { useAppStore } from '@/store/app';
import { LANGUAGES } from '@/lib/i18n';
import type { Language } from '@glintfans/shared';

// UI09: standalone auth pages keep only a light logo bar + language switch
export default function AuthBar() {
  const { theme, language, setLanguage } = useAppStore();
  return (
    <div className="mx-auto flex h-16 w-full max-w-[420px] items-center justify-between px-6">
      {/* Native full-page link: avoids client-side route-swap exceptions when
          leaving auth pages (AUD01). */}
      <a href="/markets" className="flex shrink-0 items-center">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={theme === 'light' ? '/logo-light.png' : '/logo-dark.png'}
          alt="AiLumix"
          className="h-9 w-auto rounded"
          style={{ maxWidth: 140 }}
        />
      </a>
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value as Language)}
        className="input !h-9 !w-auto !py-1 text-xs"
        aria-label="Language"
      >
        {LANGUAGES.map((l) => (
          <option key={l.value} value={l.value}>{l.label}</option>
        ))}
      </select>
    </div>
  );
}
